<template>
    <v-btn :height="height" :width="width" depressed v-bind="$attrs" v-on="$listeners" class="base-button">
        <slot></slot>
    </v-btn>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        height: {
            type: [Number, String],
            default: 65
        },
        width: {
            type: [Number, String],
            default: 180
        },
    }
};
</script>

<style lang="scss" scoped>
    @import '@sass/_variables.scss';
    .base-button{
        background-color: $bo-base-button !important;
        float: right;
    }
    ::v-deep .v-btn__content {
        text-transform: capitalize;
        font-size: 14px;
        line-height: 18px;
        font-weight: 400;
        letter-spacing: 0.14px;
        color:#4B4849;
        width: 100%;
    }
</style>
